import * as React from 'react';

import {cn} from '@/utils/ui';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({className, ...props}, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-20 w-full rounded-sharp border border-input bg-white px-4 py-2 type-body1',
          'placeholder:text-neutral-400',
          'focus-visible:border-secondary-400 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none',
          'aria-invalid:border-danger-600 aria-invalid:focus-visible:border-danger-600 aria-invalid:focus-visible:ring-danger-600',
          'disabled:cursor-not-allowed disabled:border-neutral-300 disabled:bg-neutral-100 disabled:text-neutral-500 disabled:placeholder:text-neutral-400',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export {Textarea};
